// Payroll Detail Getters

export const getPayrollDetailList = state => {
  return state.payrollDetailList
}

export const getPayrollDetailInfo = state => {
  return state.payrollDetailInfo
}
